import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { useYoneticiErisimi } from '@/hooks/useYetki'
import type { Rol } from '@/types'
import type { ReactNode } from 'react'

interface ProtectedRouteProps {
  children: ReactNode
  izinliRoller?: Rol[]
  /** true ise yönetici paneline erişim hakkı kontrol edilir (BOSS + yoneticiMi'li personel) */
  yoneticiErisimi?: boolean
}

export function ProtectedRoute({ children, izinliRoller, yoneticiErisimi }: ProtectedRouteProps) {
  const { firebaseUser, kullanici, yukleniyor } = useAuth()
  const yonetici = useYoneticiErisimi()

  if (yukleniyor) {
    return <FullPageLoader />
  }

  if (!firebaseUser || !kullanici) {
    return <Navigate to="/giris" replace />
  }

  if (!kullanici.aktif) {
    return <Navigate to="/yetkisiz" replace />
  }

  if (yoneticiErisimi && !yonetici) {
    return <Navigate to="/yetkisiz" replace />
  }

  if (izinliRoller && !izinliRoller.includes(kullanici.rol)) {
    return <Navigate to="/yetkisiz" replace />
  }

  return <>{children}</>
}

export function FullPageLoader() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-brand-600"></div>
        <p className="mt-4 text-gray-600">Yükleniyor...</p>
      </div>
    </div>
  )
}
